import React from 'react';

// Circular "click to restore" marker — same visual language as
// ProductPricesPage.js's manual-price revert glyph. Doubles as the "this
// line was overridden" badge and the revert control in one element, since
// both point at the same fact — see ui-architecture.md's Circular Revert
// Badge pattern.
function OverrideRevertBadge({ onClick, title }) {
  return (
    <span
      onClick={onClick}
      title={title}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 16, height: 16, borderRadius: '50%', backgroundColor: '#2563eb',
        color: '#fff', fontSize: 11, fontWeight: 700, lineHeight: 1, cursor: 'pointer', flexShrink: 0,
      }}
    >
      ↺
    </span>
  );
}

export default OverrideRevertBadge;
